export const getDefaultState = () => {
    return {
        ocatypes: [],
        ocatype: {
            name: null,
        },
        validation_ocatype: {
            name: null,
        },
        search:{
            name: null,
        }
    }
}
export default getDefaultState()